module.exports = __webpack_public_path__ + "img/dataIcon2.7e2ac96b.svg";